import type { PropsWithChildren } from "react";
import type { DashboardContextType } from "./DashboardContext";
import { DashboardContext } from "./DashboardContext";

export const DashboardContextProvider = ({ children, ...props }: PropsWithChildren<DashboardContextType>) => (
  <DashboardContext value={props}>{children}</DashboardContext>
);
